<template>
  <div class="payment_stripe">
    <div class="form">
      <fieldset>
        <legend class="card-only" data-tid="elements_examples.form.pay_with_card">Pay with card</legend>
        <div class="container">
          <div ref="card"></div>
          <button @click="issueToken">正式に依頼する</button>
        </div>
      </fieldset>
    </div>
  </div>
</template>

<script>
  import {loadStripe} from '@stripe/stripe-js';

  import toast from '@/assets/js/functions/_core/toast';
  import logging from '@/assets/js/functions/_core/logging';
  import caller from '@/assets/js/functions/firebase/cloud_functions/caller.js';
  import {mapGetters} from "vuex";

  let card = undefined;

  export default {
    name: 'Payment',

    mixins: [logging, caller, toast],

    data() {
      return {
        stripe: null,
        elements: null
      }
    },

    props: {
      matchingId: {
        type: String,
        required: true
      },
      amount: {
        type: Number,
        required: true
      }
    },

    computed: {
      ...mapGetters({uid: 'auth/uid'}),
    },

    async mounted() {
      this.stripe = await loadStripe(`${process.env.VUE_APP_STRIPE_PUBLIC_KEY}`);
      this.elements = this.stripe.elements();

      card = this.elements.create("card", {
        style: {
          base: {
            color: "#32325D",
            fontWeight: 500,
            fontFamily: "Inter UI, Open Sans, Segoe UI, sans-serif",
            fontSize: "16px",
            fontSmoothing: "antialiased",
            "::placeholder": {
              color: "#CFD7DF"
            }
          },
          invalid: {
            color: "#E25950"
          }
        }
      });
      card.mount(this.$refs.card)
    },

    methods: {
      async issueToken() {
        let self = this;

        this.stripe.createToken(card).then(async result => {
          if (result.error) {
            self.hasCardErrors = true;
            self.$forceUpdate(); // Forcing the DOM to update so the Stripe Element can update.
            this.logger(result, result.error.message, card);
          } else {
            const params = {
              userId: this.uid,
              matchingId: this.matchingId,
              amount: this.amount,
              token: result.token.id,
            };

            await self.callFunction('payByStripe', params
            ).then(() => {
              this.showSuccessMessage('正常に完了しました');
              this.$router.push({name: 'Meeting', params: {matchingId: this.matchingId}});
            }).catch(() => {
              // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
            })
          }
        });
      },
    }
  }
</script>

<style>
  .payment_stripe {
    margin-bottom: 3rem;
  }

  .payment_stripe .form {
    padding: 0 15px;
  }

  .payment_stripe fieldset {
    border-style: none;
    padding: 1rem;
    margin-left: -5px;
    margin-right: -5px;
    background-color: #CCCCCC;
    border-radius: 8px;
  }

  .payment_stripe fieldset legend {
    float: left;
    width: 100%;
    text-align: center;
    font-size: 13px;
    color: #8898AA;
    padding: 3px 10px 7px;
  }

  .payment_stripe .container {
    display: block;
    overflow: visible;
    background-color: #FFFFFF;
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    padding: 3px;
  }

  .payment_stripe #payment_stripe-card {
    padding: 10px;
    margin-bottom: 2px;
  }

  .payment_stripe button {
    display: block;
    width: 100%;
    height: 37px;
    background-color: #00BFFF;
    border-radius: 2px;
    color: #FFFFFF;
    cursor: pointer;
  }
</style>